import { FC } from 'react'
import * as cn from 'classnames'
import { SocialGroup } from 'interfaces/share'
import { SOCIAL_MEDIA_URLS } from 'constants/media'
import * as styles from 'components/features/socialFeed/SocialButton/SocialButton.css'
import { QAMarked } from 'interfaces/component'

type SocialButtonProps = QAMarked & {
  type: SocialGroup
}

const SocialButton: FC<SocialButtonProps> = (props) => {
  const {
    type,
    qaMarker,
  } = props

  return (
    <a
      className={ styles.socialButtonLink }
      href={ SOCIAL_MEDIA_URLS[type] }
      target='_blank'
      rel='noopener noreferrer'
      data-qa-marker={ qaMarker }
    >
      <button className={ cn(styles.socialButton, styles[type]) } />
    </a>
  )
}

export default SocialButton
